'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var DialogContent$2 = require('../../../node_modules/@material-ui/core/esm/DialogContent/DialogContent.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var styles = {
  root: {
    padding: '0px 24px 24px 24px',
    margin: '0px'
  }
};

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      props = objectWithoutProperties(_ref, ["children", "classes"]);

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(DialogContent$2["default"], _objectSpread({
    className: classes.root
  }, props), children));
};

var DialogContent$1 = withStyles(styles)(DialogContent);

module.exports = DialogContent$1;
